import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { ResponsiveContainer, AreaChart, Area } from 'recharts';
import { KPI } from '../types';
import { formatCurrency, formatNumber, formatPercentage } from '../utils/formatters';
interface KpiSectionProps {
  kpis: KPI[];
}
function Sparkline({
  data,
  color
}: {
  data: number[];
  color: string;
}) {
  const chartData = data.map((val, i) => ({
    value: val,
    index: i
  }));
  return <div className="h-12 w-24" data-id="element-184">
      <ResponsiveContainer width="100%" height="100%" data-id="element-185">
        <AreaChart data={chartData} data-id="element-186">
          <defs data-id="element-187">
            <linearGradient id={`gradient-${color}`} x1="0" y1="0" x2="0" y2="1" data-id="element-188">
              <stop offset="5%" stopColor={color} stopOpacity={0.3} data-id="element-189" />
              <stop offset="95%" stopColor={color} stopOpacity={0} data-id="element-190" />
            </linearGradient>
          </defs>
          <Area type="monotone" dataKey="value" stroke={color} strokeWidth={2} fillOpacity={1} fill={`url(#gradient-${color})`} isAnimationActive={false} data-id="element-191" />
        </AreaChart>
      </ResponsiveContainer>
    </div>;
}
export function KpiSection({
  kpis
}: KpiSectionProps) {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-8" data-id="element-192">
      {kpis.map(kpi => {
      const isPositive = kpi.trendDirection === 'up';
      const isNegative = kpi.trendDirection === 'down';
      const trendColor = isPositive ? 'text-emerald-400' : isNegative ? 'text-rose-400' : 'text-slate-400';
      const sparklineColor = isPositive ? '#34d399' : isNegative ? '#fb7185' : '#94a3b8';
      let displayValue = '';
      if (kpi.format === 'currency') displayValue = formatCurrency(kpi.value as number);else if (kpi.format === 'short-currency') displayValue = formatCurrency(kpi.value as number, true);else displayValue = formatNumber(kpi.value as number);
      return <div key={kpi.id} className="glass-panel rounded-2xl p-5 flex flex-col justify-between" data-id="element-193">
            <div className="flex justify-between items-start mb-4" data-id="element-194">
              <h3 className="text-slate-400 text-sm font-medium" data-id="element-195">
                {kpi.title}
              </h3>
            </div>

            <div className="flex items-end justify-between" data-id="element-196">
              <div data-id="element-197">
                <div className="text-2xl font-bold text-white mb-1 tracking-tight" data-id="element-198">
                  {displayValue}
                </div>
                <div className={`flex items-center text-xs font-medium ${trendColor}`} data-id="element-199">
                  {isPositive && <TrendingUp className="w-3 h-3 mr-1" data-id="element-200" />}
                  {isNegative && <TrendingDown className="w-3 h-3 mr-1" data-id="element-201" />}
                  {!isPositive && !isNegative && <Minus className="w-3 h-3 mr-1" data-id="element-202" />}
                  {formatPercentage(kpi.trend)} MoM
                </div>
              </div>
              <Sparkline data={kpi.history} color={sparklineColor} data-id="element-203" />
            </div>
          </div>;
    })}
    </div>;
}